/**
 * This is a singleton class to handle expried token in calling api
 * Can refresh token if got 401 and 'token-expried' in header
 * Retry the failed requests
 */
import { LodashUtils } from '@utils/lodash'

class TokenHandlerModel {
  private static instance: TokenHandlerModel
  private requests: any[] = []
  public isRefreshing = false

  public static getInstance(): TokenHandlerModel {
    if (!TokenHandlerModel.instance) {
      TokenHandlerModel.instance = new TokenHandlerModel()
    }
    return TokenHandlerModel.instance
  }

  public isExpiredToken(header: any): boolean {
    const hasExpired = LodashUtils.get(header, 'token-expired', 'false')
    return hasExpired === 'true' || hasExpired === true
  }

  public get refreshing(): boolean {
    return this.isRefreshing
  }

  public set refreshing(value: boolean) {
    this.isRefreshing = value
  }

  public cacheRequest(request: any): void {
    this.requests.push(request)
  }

  public releaseRequests(token: string): void {
    this.requests.forEach((req) => req(token))
    this.reset()
  }

  private reset(): void {
    this.requests.length = 0
    this.isRefreshing = false
  }
}

export const TokenHandler = TokenHandlerModel.getInstance()
